import { PacksClient } from '../types'

export const getIcon = (base: PacksClient) => (id: string, hash: string) =>
  base.requester.get(`/${id}/assets/${hash}/icon`, { withCredentials: true, responseType: "arraybuffer" })
